import { Tooltip, Switch, Label } from "@altimateai/lego";
import { Spinner, Stack } from "@altimateai/lego";
import { Alert, toast } from "@altimateai/lego";
import useMCPContext from "@/pages/mcp/useMCPContext";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editDatamate } from "@/helpers/apis";
import { TeammatesApplicableFor } from "@/pages/mcp/constants";
import { useEffect } from "react";

interface Props {
  showInfo?: boolean;
}

const InfoText =
  "Memory gives an Agent the ability to recall relevant information. Capture every coding insight, architectural decision, and tribal knowledge with our intelligent memory management system";
const MemoryToggle = ({ showInfo }: Props) => {
  const { teammate, updateTeammate } = useMCPContext();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (typeof teammate?.memory_enabled === "undefined") {
      updateTeammate({ memory_enabled: true });
    }
  }, [teammate?.memory_enabled, updateTeammate]);

  // mutation for updating teammate
  const { mutate, isPending: isLoading } = useMutation({
    // @ts-ignore
    mutationFn: (isEnabled: boolean) => {
      if (teammate?.id) {
        return editDatamate(teammate.id, { ...teammate, memory_enabled: isEnabled });
      }
      updateTeammate({ memory_enabled: isEnabled });
    },
    onSuccess: () => {
      if (teammate?.id) {
        queryClient.invalidateQueries({ queryKey: [`FILTER_${TeammatesApplicableFor}`] });
      }
    },
    onError: (error: unknown) => {
      toast({
        title: "Could not update datamate",
        description: (error as Error).message,
        variant: "destructive",
      });
    },
  });

  return (
    <Stack direction="column" align="start" justify="start">
      <div className="al-p-0">
        <Tooltip title={teammate?.memory_enabled ? "Memory is enabled" : "Memory is disabled"}>
          <Stack direction="row" align="center">
            <Label htmlFor="memory-toggle" className="al-m-0">
              Memory
            </Label>
            {isLoading ? (
              <Spinner size="sm" />
            ) : (
              <Switch
                id="memory-toggle"
                checked={teammate?.memory_enabled || false}
                onCheckedChange={checked => mutate(checked)}
                className="!al-ml-0"
              />
            )}
          </Stack>
        </Tooltip>
      </div>
      {showInfo && <Alert>{InfoText}</Alert>}
    </Stack>
  );
};

export default MemoryToggle;
